import { StyleSheet, View, Pressable } from 'react-native';
import { Icon, Text, theme } from '@socrait/react';

import { Period } from '~/services/types';

type ClassListItemProps = {
  period: Period;
  onPeriodSelect: (period: Period) => void;
};

export function ClassListItem({ period, onPeriodSelect }: ClassListItemProps) {
  const { name, shortName, students } = period;

  return (
    <Pressable style={styles.itemContainer} onPress={() => onPeriodSelect(period)}>
      {({ hovered, pressed }) => {
        const isActive = hovered || pressed;
        return (
          <>
            <View style={[styles.snContainer, isActive && { backgroundColor: theme.colors.navy }]}>
              <Text style={[styles.boldText, isActive && { color: theme.colors.white }]}>{shortName}</Text>
            </View>
            <View style={[styles.fullNameContainer, isActive && styles.fullNameHover]}>
              <Text numberOfLines={1}>{name}</Text>
            </View>
            <View style={styles.studentCountContainer}>
              <Text style={[styles.boldText, (!students || students.length === 0) && styles.redText]}>
                {students?.length ?? 0}
              </Text>
              <Icon type="group" fill={!students || students.length === 0 ? theme.colors.red : theme.colors.navy} />
            </View>
            {isActive && (
              <View style={styles.editIconContainer}>
                <Icon type="edit" fill={isActive ? theme.colors.white : theme.colors.navy} />
              </View>
            )}
          </>
        );
      }}
    </Pressable>
  );
}

const styles = StyleSheet.create({
  itemContainer: {
    display: 'flex',
    flexDirection: 'row',
    height: 50,
    gap: theme.spacing.xlarge,
  },
  snContainer: {
    alignItems: 'center',
    backgroundColor: theme.colors.gray,
    borderRadius: theme.borderRadius.xlarge * 5,
    justifyContent: 'center',
    height: 50,
    width: 50,
  },
  fullNameContainer: {
    borderBottomColor: theme.colors.darkGray,
    borderBottomWidth: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingHorizontal: theme.spacing.large,
    width: '70%',
  },
  fullNameHover: {
    borderBottomColor: theme.colors.navy,
  },
  studentCountContainer: {
    alignItems: 'center',
    alignSelf: 'center',
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing.medium,
    justifySelf: 'flex-end',
    justifyContent: 'flex-end',
    width: 50,
  },
  editIconContainer: {
    alignItems: 'center',
    borderRadius: theme.borderRadius.large,
    backgroundColor: theme.colors.navy,
    height: 50,
    justifyContent: 'center',
    width: 50,
  },
  boldText: {
    fontWeight: theme.fontWeights.bold,
  },
  redText: {
    color: theme.colors.red,
  },
});
